module.exports = __webpack_public_path__ + "static/media/user_profile_icon.2c6e94aa.png";